import Vue from "vue";

import {
  message,
  Modal
} from 'ant-design-vue';

const namespaced = true;

function initialState() {
  return {
    bookingRequests: {}
  };
}

const state = {
  bookingRequests: initialState().bookingRequests,
};

const mutations = {
  SET_BOOKINGREQUEST: (state, bookingRequest) => {
    Vue.set(state.bookingRequests, bookingRequest.id, bookingRequest);
  },
  UNSET_BOOKINGREQUEST: (state, id) => {
    Vue.delete(state.bookingRequests, id);
  }
};

const actions = {
  create: ({
    commit
  }, bookingRequest) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`/public/bookingRequest`, {
          bookingRequest: bookingRequest
        })
        .then(response => {
          // commit("SET_BOOKINGREQUEST", response.data.bookingRequest);
          // message.success(`BookingRequest has been created!`);
          resolve(response.data.bookingRequest);
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  fetchSingle: ({
    commit
  }, {
    id,
    include
  }) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`/bookingRequest/${id}?include=${include}`)
        .then(response => {
          commit("SET_BOOKINGREQUEST", response.data.bookingRequest);
          resolve(response.data.bookingRequest);
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  fetchAllByEvent: ({
    commit
  }, {
    eventId,
    isPublic
  }) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`${isPublic ? '/public' : ''}/bookingRequest/getByEvent/${eventId}`)
        .then(response => {
          for (const bookingRequest of response.data.bookingRequests) {
            commit("SET_BOOKINGREQUEST", bookingRequest);
          }
          resolve();
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  fetchAll: ({
    commit
  }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`/bookingRequest${data.queryString ? '?' + data.queryString : ''}`)
        .then(response => {
          for (const bookingRequest of response.data.bookingRequests) {
            commit("SET_BOOKINGREQUEST", bookingRequest);
          }
          resolve(response.data.bookingRequests);
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  update: ({
    commit
  }, bookingRequest) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .put(`/bookingRequest/${bookingRequest.id}`, {
          bookingRequest: bookingRequest
        })
        .then(response => {
          commit("SET_BOOKINGREQUEST", response.data.bookingRequest);
          message.success(`BookingRequest has been created!`);
          resolve(response.data.bookingRequest);
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  delete: ({
    state,
    commit
  }, id) => {
    return new Promise((resolve, reject) => {

      const bookingRequest = state.bookingRequests[id];

      Modal.confirm({
        title: 'Delete bookingRequest',
        content: `Permanently delete bookingRequest. Continue?`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk: () => {
          Vue.axios
            .delete(`/admin/bookingRequest/${id}`)
            .then(response => {
              commit("UNSET_BOOKINGREQUEST", id);
              message.success(`BookingRequest has been deleted!`);
              resolve();
            })
            .catch(error => {
              message.error(`Error while deleting bookingRequest!`);
              Vue.prototype.$log.error(error);
            });
        }
      });
    });
  }
};

const getters = {
  all: (state, getters, rootState) => {
    if (rootState.isLoading) return {};
    return state.bookingRequests;
  },
  asArray: (state, getters, rootState) => {
    if (rootState.isLoading) return [];
    return Object.values(state.bookingRequests);
  }
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
};